export var GameStatus;
(function (GameStatus) {
    GameStatus[GameStatus["UNSTARTED"] = 0] = "UNSTARTED";
    GameStatus[GameStatus["INTRO"] = 1] = "INTRO";
    GameStatus[GameStatus["ONGOING"] = 2] = "ONGOING";
    GameStatus[GameStatus["PAUSED"] = 3] = "PAUSED";
    GameStatus[GameStatus["FINISHED"] = 4] = "FINISHED";
    GameStatus[GameStatus["ERROR"] = 5] = "ERROR";
})(GameStatus || (GameStatus = {}));
